// import ComponentA from './Components/ComponentA'
import Menu from './Components/Menu'
import Upload from './Components/Upload'
import Delete from './components/Delete'
import DownloadManager from './components/DownloadManager'
import UploadDynamic from './components/UploadDynamic'
import WIP from './components/WIP'

document.addEventListener('DOMContentLoaded', () => {
    let root = {}
    root.menu = new Menu(root, [])
    root.menu.run()

    root.upload = new Upload(root, [])
    root.UploadDynamic = new UploadDynamic(root, [])
    root.delete = new Delete(root, [])
    root.downloadManager = new DownloadManager(root, [])

    new WIP()
}, false)